import { PropTypes } from 'prop-types';
import './StatusLabel.css'
StatusLabel.propTypes = {
    text: PropTypes.string,
}
export default function StatusLabel(props) {
    const statusColors={
        'Before Start': 'gray',
        'In Progress': 'yellow',
        'Completed': 'green',
        'Boarded Bus': 'yellow',
        'Boarded': 'yellow',
        'Dropped Off': 'green',
    }
    return <div className={`list-status ${statusColors[props.text]}`}>{props.text}</div>
}